import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, WidthType } from "docx";

function numberToWords(num) {
    const words = [
        "zero", "one", "two", "three", "four", "five",
        "six", "seven", "eight", "nine", "ten",
        "eleven", "twelve", "thirteen", "fourteen", "fifteen",
        "sixteen", "seventeen", "eighteen", "nineteen", "twenty",
        "twenty-one", "twenty-two", "twenty-three", "twenty-four", "twenty-five",
        "twenty-six", "twenty-seven", "twenty-eight", "twenty-nine", "thirty"
    ];

    if (num <= 30) return words[num];
    return num.toString();
}

export function observartionSummaryText(vulCount) {
    const vulCountFormatted = `${numberToWords(vulCount)} (${vulCount})`;

    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        indent: { left: 600, right: 600 },
        spacing: { line: 350, before: 300, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `During the security testing exercise, ISECURION security testing team (hereafter referred as the ‘testing team’) identified ${vulCountFormatted} Vulnerabilities in the Internal IP address. To enable risk-focused mitigation, these vulnerabilities are summarized in five different categories (Critical, High, Medium, Low and Information). The scale shown below has been used to rate the level of risk:`,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
        ],
    })
}


export const vulnerabilityTable = new Table({
    width: { size: 89, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    borders: {
        top: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        bottom: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        left: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
        right: {
            style: BorderStyle.SINGLE,
            size: 1,
            color: "ffffff",
        },
    },

    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Rating",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "0189f9",
                    },
                    indent: {
                        left: 600
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "0189f9",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "H (High)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "c00000",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [

                        new Paragraph({

                            indent: {
                                left: 100,
                                right: 100,

                            },
                            shading: {
                                type: ShadingType.SOLID,
                                color: "c00000",
                            },
                            spacing: { line: 276, after: 350 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Serious impact to the application security, generally unmitigated, large-scale issues, such as an attack that is currently exploitable from the Internet.",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false,
                                    color: "000000"
                                }),
                            ]
                        }),

                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "c00000",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),


            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "M (Medium)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffc000",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Notable impact to the application security, or somewhat mitigated high risks (e.g., being available only to the user's Intranet)",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),

                            ]
                        }),

                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "ffc000",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),


            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "L (Low)",
                                    font: "Calibri",
                                    size: 22,
                                    color: '0f0f3f',
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "00b050",
                    },

                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Potential impact to the application security, or heavily mitigated high risk (e.g., being in dead code or after an abort call).",
                                    font: "Calibri",
                                    size: 22,
                                    italics: false
                                }),

                            ]
                        }),

                    ],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "00b050",
                    },
                    borders: {
                        top: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        bottom: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        left: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                        right: {
                            style: BorderStyle.SINGLE,
                            size: 1,
                            color: "ffffff",
                        },
                    },
                }),


            ]
        }),



    ]
})